import { axiosClient } from "../api-client";

// type Prop = {
// 	config?: AxiosRequestConfig;
// 	body?: any;
// 	param?: string;
// };

export function GetMe({ config, body }) {
	return axiosClient.get("/v1/users/" + body, config);
}

export function UpdateMe({ config, body }) {
	const id = body._id;
	delete body._id;
	return axiosClient.patch("/v1/users/" + id, body, config);
}
export function GetCard({ config, body }) {
	return axiosClient.get("v1/payment/admin/source/detail/" + body, config);
}
